import { render, staticRenderFns } from "./SingleContactImport.vue?vue&type=template&id=167a8454&scoped=true"
import script from "./SingleContactImport.vue?vue&type=script&lang=js"
export * from "./SingleContactImport.vue?vue&type=script&lang=js"
import style0 from "./SingleContactImport.vue?vue&type=style&index=0&id=167a8454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167a8454",
  null
  
)

export default component.exports